import React, { Component } from 'react';
import { GlobalContext } from '../../interfaces/GlobalContext/GlobalContext';
import Option from '../../interfaces/Option/Option';
import ProductPrice from '../../interfaces/ProductPrice/ProductPrice';
import ProductProperties, { FormFieldName } from '../../interfaces/ProductProperties/ProductProperties';
import { ProductType } from '../../interfaces/ProductProperties/ProductPropertiesRelated';
import { ButtonType } from '../Button/Button.props';
import OverlayButton from '../OverlayButton/OverlayButton';
import ProductPropertiesOverlay from '../ProductPropertiesOverlay/ProductPropertiesOverlay';
import { Wrap } from '../Wrap/Wrap';
import CartPageItemProps, { CartPageItemType } from './CartPageItem.props';
import CartPageItemState from './CartPageItem.state';
import OptionOverlay from '../OptionOverlay/OptionOverlay';
import productProvider from '../../services/ProductProvider/ProductProvider';

export default class CartPageItem extends Component<CartPageItemProps, CartPageItemState> {
    static contextType = GlobalContext;
    context!: React.ContextType<typeof GlobalContext>;
    closeButtonRef: React.RefObject<HTMLButtonElement>;

    constructor(props: CartPageItemProps) {
        super(props);
        this.state = {
            price: {
                magicNumber: this.props.productProperties.magicNumber,
                paymentPeriod: this.props.productProperties.configOptions?.find(option => option.name === FormFieldName.PAYMENTPERIOD)?.value || '1M',
                price: 0.0,
                priceInclMwst: 0.0,
            },
            isRemoveOptionOverlayOpen: false
        };

        this.closeButtonRef = React.createRef<HTMLButtonElement>();
        this.handleRemoveProductInformation = this.handleRemoveProductInformation.bind(this);
        this.emitPrice = this.emitPrice.bind(this);
    }

    handleRemoveProductInformation() {
        this.context.localStorageProvider.removeProductInformationFromLocalStorage(this.props.productProperties.magicNumber);
        this.updatePrices();
        this.updateCartCounter();
    }

    updatePrices() {
        this.props.updatePrices && this.props.updatePrices({
            magicNumber: this.props.productProperties.magicNumber,
            paymentPeriod: this.props.productProperties.configOptions?.find(option => option.name === FormFieldName.PAYMENTPERIOD)?.value || '1M',
            price: 0.0,
            priceInclMwst: 0.0,
        });
    }

    updateCartCounter() {
        try {
            if (window.Juris.moduleRegistry._registeredModules.get("Navigation").instances.entries().next().value) {
                window.Juris.moduleRegistry._registeredModules.get("Navigation").instances.entries().next().value[1]._updateCounter();
            }
        } catch (error) {
            this.context.logger.error("No Navigation on the page.", error);
        }
    }

    updateBookmarkCounter() {
        try {
            if (window.Juris.moduleRegistry._registeredModules.get("Bookmarks").instances.entries().next().value) {
                window.Juris.moduleRegistry._registeredModules.get("Bookmarks").instances.entries().next().value[1].updateCounter();
            }
        } catch (error) {
            this.context.logger.error("No Navigation on the page.", error);
        }
    }

    emitPrice(price: ProductPrice) {
        this.setState({
            price: price
        });
        this.props.updatePrices && this.props.updatePrices(price);
    }

    renderPriceContainer(): React.ReactElement<HTMLElement> {
        switch (this.props.type) {
            case CartPageItemType.SERVICE:
                return <>
                    <em className="cart-page__price">{this.context.i18nProvider.get
                        ? this.context.i18nProvider.get('cartpageServiceItem.price') as string
                        : ''}</em>
                    <div className="textblock cart-page__price-text"
                        dangerouslySetInnerHTML={{
                            __html: (this.context.i18nProvider.get
                                ? this.context.i18nProvider.get('cartpageServiceItem.priceText') as string
                                : '')
                        }}>
                    </div>
                </>

            case CartPageItemType.TEST:
                return <>
                    <em className="cart-page__price">{this.context.i18nProvider.get('cartpageTestItem.price')}</em>
                    <span className="cart-page__price-suffix">
                        {
                            !this.context.globalStates.getDiscountStatusFromProductProperties(this.props.productProperties)
                                ? this.context.i18nProvider.get('cartpageTestItem.priceSuffix') 
                                : this.context.i18nProvider.get('cartpageTestItem.priceSuffixDiscount')
                        }
                    </span>
                    <div className="textblock cart-page__price-text"
                        dangerouslySetInnerHTML={{ __html: this.context.i18nProvider.get('cartpageTestItem.priceText') || '' }}></div>
                </>

            // CartPageItemType.PRODUCT
            default:
                return <>
                    {/* <!-- z.B. "35,00 € / Jahr" -> "35,00 €" --> */}
                    <em className="cart-page__price">{this.state.price.price.toLocaleString('de-DE', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                        useGrouping: true
                    })}</em>
                    {/* <!-- z.B. "35,00 € / Jahr" -> " / Jahr" --> */}

                    <span className="cart-page__price-suffix"> {
                        this.context.i18nProvider.get('generalRessources.currency')
                    } {this.props.cartPage && (this.context.i18nProvider.get('generalRessources.priceSuffix') as string)
                        .replace(
                            '{{paymentperiod}}',
                            this.context.i18nProvider.get(`productPropertiesOverlay.${FormFieldName.PAYMENTPERIOD}.periods.${this.props.productProperties.configOptions?.find(
                                option => option.name === FormFieldName.PAYMENTPERIOD
                            )?.value}`) || ''
                        )}</span>
                    {this.props.cartPage &&
                        <div className="textblock cart-page__price-text"
                            dangerouslySetInnerHTML={{
                                __html: (this.context.i18nProvider.get
                                    ? this.context.i18nProvider.get('generalRessources.allContractInformation') as string
                                    : '')
                            }}>
                        </div>
                    }
                    <div className='cart-page__product-teaser cart-page__product-license' dangerouslySetInnerHTML={{
                        __html: (this.props.license
                            ? `${this.props.license} ${this.context.i18nProvider.get('checkDataPage.license')}` as string
                            : '')
                    }}>
                    </div>

                    {this.props.productProperties.productType === ProductType.VARIANT &&
                        <div className='cart-page__product-variant' dangerouslySetInnerHTML={{
                            __html: (this.props.productProperties.title as string)
                        }}>
                        </div>
                    }

                    {this.renderAdditionalInformation(FormFieldName.NUMBEROFDAVUSERS)}
                    {this.renderAdditionalInformation(FormFieldName.MEMEBEROFDAV)}
                    {this.renderAdditionalInformation(FormFieldName.MEMBEROFDNOTV)}
                    {this.renderAdditionalInformation(FormFieldName.JOBBRANCH)}

                    {!this.props.cartPage &&
                        <div className="textblock cart-page__price-text cart-page__price-text--check-data-page"
                            dangerouslySetInnerHTML={{
                                __html: (this.context.i18nProvider.get
                                    ? (this.context.i18nProvider.get('generalRessources.priceSuffix') as string).replace(
                                        '{{paymentperiod}}',
                                        this.context.i18nProvider.get(`productPropertiesOverlay.${FormFieldName.PAYMENTPERIOD}.periods.${this.props.productProperties.configOptions?.find(
                                            option => option.name === FormFieldName.PAYMENTPERIOD
                                        )?.value}`) || ''
                                    )
                                    : '')
                            }}>
                        </div>
                    }
                </>
        }
    }

    renderAdditionalInformation(formFieldName: FormFieldName): JSX.Element | undefined {
        const formFieldExists = this.props.productProperties.configOptions?.find(productOption => productOption.name === formFieldName);

        if (formFieldExists) {
            switch (formFieldName) {
                case FormFieldName.NUMBEROFDAVUSERS:
                    return <div className="cart-page__product-teaser cart-page__number-of-dav"
                        dangerouslySetInnerHTML={{
                            __html: formFieldExists.value + ' ' + (this.context.i18nProvider.get('checkDataPage.davMembersLabel'))
                        }}>
                    </div>;
                case FormFieldName.MEMEBEROFDAV:
                    return <div className="cart-page__product-teaser cart-page__dav-member"
                        dangerouslySetInnerHTML={{
                            __html: this.context.i18nProvider.get('checkDataPage.davSingleMemberLabel') + ': ' + (formFieldExists.value === "true" ? 'Ja' : 'Nein')
                        }}>
                    </div>;
                case FormFieldName.MEMBEROFDNOTV:
                    return <div className="cart-page__product-teaser cart-page__dnv-member"
                        dangerouslySetInnerHTML={{
                            __html: this.context.i18nProvider.get('checkDataPage.dnvSingleMemberLabel') + ': ' + (formFieldExists.value === "true" ? 'Ja' : 'Nein')
                        }}>
                    </div>;
                default:
                    return undefined;
            }
        }

        if (formFieldName === FormFieldName.JOBBRANCH) {
            const productIsForLawyer = this.props.productProperties.productType === ProductType.FOR_LAWYER;
            const productIsForOther = this.props.productProperties.productType === ProductType.FOR_OTHER;

            if (!(productIsForLawyer || productIsForOther)) {
                return undefined;
            }

            const productHasCorrespondingProduct = productIsForOther
                ? this.context.utilityProvider.getForLawyerProductFromProductProperties(this.props.productProperties)
                : productIsForLawyer
                    ? this.context.utilityProvider.getForOtherProductFromProductProperties(this.props.productProperties)
                    : undefined;

            if (!productHasCorrespondingProduct) {
                return undefined;
            }

            const option = (this.context.i18nProvider.get(`productPropertiesOverlay.${FormFieldName.JOBBRANCH}.choices`, {
                returnObjects: true,
            }) as unknown as Option[]).find(option => option.value === String(productIsForOther));

            if (option !== undefined) {
                return <div className="cart-page__product-teaser cart-page__dnv-member"
                    dangerouslySetInnerHTML={{
                        __html: option.label
                    }}>
                </div>;
            }
        }
        return undefined;
    }

    renderActions(): React.ReactElement<HTMLElement> {
        switch (this.props.type) {
            case CartPageItemType.SERVICE:
                return <></>

            case CartPageItemType.TEST:
                return this.renderRemoveButton();

            // CartPageItemType.PRODUCT
            default:
                return <>
                    <div className="cart-page__overlay-button">
                        <OverlayButton label={this.props.cartPage ? this.context.i18nProvider.get("cartPage.overlayButton.text") : undefined}
                            closeButtonRef={this.closeButtonRef}
                            type={ButtonType.TEXTICONLINK}>
                            <ProductPropertiesOverlay magicNumber={this.props.productProperties.magicNumber}
                                closeButtonRef={this.closeButtonRef}
                                emitPrice={this.emitPrice} />
                        </OverlayButton>
                    </div>
                    <div className="cart-page__info" data-tooltip={false}>
                        <span className="icon_error-circle_alt"></span>
                        {
                            this.props.cartPage &&
                            <span className="cart-page__info-label">{this.context.i18nProvider.get('generalRessources.contractInformation.label')}</span>
                        }
                        <div className="cart-page__info-tooltip" data-tooltip-content={false}
                            dangerouslySetInnerHTML={{
                                __html: (this.context.i18nProvider.get
                                    ? this.context.i18nProvider.get('generalRessources.contractInformation.text') as string
                                    : '')
                            }}>
                        </div>
                    </div>
                    {
                        this.renderRemoveButton()
                    }
                </>
        }
    }

    toggleOptionOverlay() {
        this.setState(
            {
                isRemoveOptionOverlayOpen: !this.state.isRemoveOptionOverlayOpen
            }
        )
    }

    addTestProductFromCurrentProductToCart() {
        // console.log('current Product', this.props.productProperties);
        this.getTestProductFromProduct(this.props.productProperties).then((testProductProperties: ProductProperties) => {
            // console.log('test Product', testProductProperties);
            // switch loaded testproduct with current product
            this.context.localStorageProvider.setProductInformationInLocalStorage(testProductProperties);
            //this.handleRemoveProductInformation(); // used as workaround for updating the ui
            this.updatePrices();
            this.updateCartCounter();
        });
    }

    async getTestProductFromProduct(productProperties: ProductProperties): Promise<ProductProperties> {
        // 1. load the solr data from the product with the given magic number (from product, not testproduct)
        const testProductMagicNumber = await productProvider.getTestProductMagicNumberFromSolr(productProperties.magicNumber);
        // console.log('# from solr', testProductMagicNumber);

        // 2. load the product properties for the given magic number of the product
        const testProductProperties = await this.getProductPropertiesForMagicNumber(testProductMagicNumber);
        if (testProductProperties) {
            testProductProperties.queryInformation = await productProvider.getProductInformationFromSolr(
                testProductProperties.magicNumber,
                testProductProperties.productType === ProductType.TEST
            );
        }

        // 3. check if the product has the product type 'test'
        // console.log('testProductProperties', testProductProperties);
        return new Promise((resolve, reject) => {
            if (testProductProperties?.productType === ProductType.TEST) {
                resolve(testProductProperties);
            }
            reject(new Error('No test product properties found'));
        });
    }

    async getProductFromTestProduct(productProperties: ProductProperties): Promise<ProductProperties> {
        // 1. load the solr data from the product with the given magic number (from product, not testproduct)
        const productMagicNumber = await productProvider.getProductMagicNumberByTestProductFromSolr(productProperties.magicNumber);
        // console.log('getProductFromTestProduct() - loaded magic number from product', productMagicNumber);

        // 2. load the product properties for the given magic number of the product
        const currentProductProperties = await this.getProductPropertiesForMagicNumber(productMagicNumber);
        if (currentProductProperties) {
            currentProductProperties.queryInformation = await productProvider.getProductInformationFromSolr(
                currentProductProperties.magicNumber,
                currentProductProperties.productType === ProductType.TEST
            );
        }

        // 3. check if the product has the product type 'test'
        return new Promise((resolve, reject) => {
            // console.log('getProductFromTestProduct() - checking product type', currentProductProperties);
            if (currentProductProperties && currentProductProperties.productType !== ProductType.TEST) {
                resolve(currentProductProperties);
            }
            reject(new Error('No product properties found'));
        });
    }

    getProductPropertiesForMagicNumber(magicNumber: string): Promise<ProductProperties | undefined> {
        const url = `/order-api/getOrderInformation/${magicNumber}`;
        const data = this.context?.requestProvider.getData(url);
        // console.log('getProductPropertiesForMagicNumber()', magicNumber, data);
        return data;
    }

    async removeProductPropertiesFromCartAndAddToBookmarkList() {
        let productProperties = this.props.productProperties;

        // check if current product is testproduct
        if (productProperties.productType === ProductType.TEST) {
            productProperties = await this.getProductFromTestProduct(productProperties);
        }

        const productId = await productProvider.getProjectProductIdFromSolr(
            productProperties.magicNumber, false);
        if (productId) {
            this.context.localStorageProvider.addBookmarkDataToLocalStorage(productId);
            this.handleRemoveProductInformation();
            this.updateBookmarkCounter()
        } else {
            console.error('No product id found', productId);
        }
    }

    renderRemoveButton(): React.ReactElement<HTMLElement> {
        return this.props.cartPage ?
            <div className="cart-page__remove">
                <button className="text-icon-link text-icon-link--button text-icon-link--trash"
                    onClick={() => this.toggleOptionOverlay()}
                    type="button">
                    <span className="text-icon-link__icon"></span>
                    <span className="text-icon-link__text">{this.context.i18nProvider.get('cartPage.remove.text')}</span>
                </button>
                <OptionOverlay isOpen={this.state.isRemoveOptionOverlayOpen} onClose={() => this.toggleOptionOverlay()}>
                    <>
                        <button className="text-icon-link text-icon-link--button text-icon-link--trash"
                            type="button"
                            onClick={this.handleRemoveProductInformation}>
                            <span className="text-icon-link__icon"></span>
                            <span className="text-icon-link__text">{this.context.i18nProvider.get('cartPage.removeOverlay.buttonRemoveTotally.title')}</span>
                        </button>
                        <button className="text-icon-link text-icon-link--button text-icon-link--cart"
                            onClick={() => this.removeProductPropertiesFromCartAndAddToBookmarkList()}
                            type="button">
                            <span className="text-icon-link__icon"></span>
                            <span className="text-icon-link__text">{this.context.i18nProvider.get('cartPage.removeOverlay.buttonAddToWishlist.title')}</span>
                        </button>
                        {this.props.productProperties.productType !== ProductType.TEST && (
                            <button className="text-icon-link text-icon-link--button text-icon-link--shopping-cart"
                                onClick={() => this.addTestProductFromCurrentProductToCart()}
                                type="button">
                                <span className="text-icon-link__icon"></span>
                                <span className="text-icon-link__text">{this.context.i18nProvider.get('cartPage.removeOverlay.buttonSelectTestproduct.title')}</span>
                            </button>
                        )}

                    </>
                </OptionOverlay>
            </div> : <></>
    }

    render(): React.ReactNode {
        return (
            <li className={'cart-page__product cart-page__product--' + (this.props.type || CartPageItemType.PRODUCT)}>
                <a className="cart-page__product-image-wrapper" href={
                    this.props.productProperties.queryInformation.href
                        ? this.context.i18nProvider.get('generalRessources.baseUrl') + this.props.productProperties.queryInformation.href
                        : undefined
                }>
                    <img className="cart-page__product-image"
                        src={this.props.productProperties.queryInformation.imageSrc}
                        alt={this.props.productProperties.queryInformation.imageAlt}
                        loading="lazy" />
                </a>
                <div className="cart-page__price-container">
                    <strong className="cart-page__product-title">{this.props.productProperties.queryInformation.title}</strong>
                    {
                        this.renderPriceContainer()
                    }
                </div>
                <Wrap
                    if={!this.props.cartPage as boolean}
                    with={(children) => {
                        return <div className="cart-page__license-actions-wrapper">
                            {/* {
                                this.props.license && <div className="textblock cart-page__license-text">
                                    {this.props.license} {this.context.i18nProvider.get('checkDataPage.license')}
                                </div>
                            } */}
                            {children}
                        </div>;
                    }} >

                    <div className={`cart-page__actions ${!this.props.cartPage ? "cart-page__actions--check-data-page" : ""}`}>
                        {
                            this.renderActions()
                        }
                    </div>
                </Wrap>
            </li>
        );
    }
}
